export default function Logo({ small = false, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Lateresina"
      data-testid="logo-mark"
      className={`${small ? "h-8" : "h-16 sm:h-20"} w-auto rounded-sm ${className}`}
    />
  );
}
